import React, { useState, useRef } from "react";
import { Tabs, Tab, Col, Row, Pagination, Button } from "react-bootstrap";
import SurveyBarChart from "./charts/SurveyBarChart";
import QuestionBarChart from "./charts/QuestionBarChart";
import { GetToken } from "../common/getToken";
import { useNavigate, useParams, Link } from "react-router-dom";
import QuestionModal from "./QuestionModal";
import AllQuestionsGrid from "./Grid/AllQuestionsGrid";
import { FaLongArrowAltLeft } from "react-icons/fa";
import GraphQuestionsGrid from "./Grid/GraphQuestionsGrid";
import QuestionFilterBox from "./QuestionFilterBox";
import axios from "axios";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { QuestionType, OrderBy, DateRange } from "./Filter";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import QuestionDropDownChart from "./charts/QuestionDropDownChart";
import QuestionMCQChart from "./charts/QuestionMCQChart";
import QuestionGroupRatingChart from "./charts/QuestionGroupRatingChart";
import QuestionMultipleMCQChart from "./charts/QuestionMultipleMCQChart";
import QuestionRatingChart from "./charts/QuestionRatingChart";
import QuestionGroupRatingGrid from "./Grid/QuestionGroupRatingGrid";

const QuestionAnalyticsTab = ({
  overview,
  surveyDetails,
  BASE_URL,
  surveyId,
}) => {
  const { REACT_APP_BASE_URL } = process.env;
  const { REACT_APP_API_URL } = process.env;

  /* variable declarations */
  pdfMake.vfs = pdfFonts.vfs;

  let history = useNavigate();
  const childRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [questionId, setQuestionId] = useState();
  const [questionText, setQuestionText] = useState();
  const [popupdata, setpopupdata] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTabSecond, setLoadingTabSecond] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [detailGraph, setDetailGraph] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [activeTab, setActiveTab] = useState("surveyAnalytics");
  const [activePage, setActivePage] = useState(() => 1);
  const [PageNumberCount, setPageNumberCount] = useState(() => 1);
  const [limit, setLimit] = useState(() => 1);
  const [answerTypeId, setAnswerTypeId] = useState();
  const [searchInputData, setSearchInputData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [sortBy, setSortBy] = useState();
  const [totalQuestions, setTotalQuestions] = useState();
  const [overviewData, setOverviewData] = useState([]);
  const [filterButton, setFilterButton] = useState("side");

  let items = [];
  let questions = "Total Questions:";
  let response = "Total Responses:";
  let surveyees = "Total Respondents:";

  for (let number = 1; number <= Math.ceil(totalQuestions / 5); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePage}
        onClick={() => setLimit(number)}
      >
        {number}
      </Pagination.Item>,
    );
  }

  useEffect(() => {
    // getSurveyAnalytics(surveyId);
    getQuestionAnalytics(surveyId);
  }, [
    allQuestions,
    history,
    surveyId,
    limit,
    answerTypeId,
    searchInputData,
    startDate,
    endDate,
    sortBy,
  ]);

  const getQuestionAnalytics = async (surveyId) => {
    setLoading(true);
    const detailGraphsPageChange = async (
      Limit = 1,
      searchInputData,
      AnswerTypeId,
      StartDate, //"2021-07-20"
      EndDate,
      SortBy,
    ) => {
      setLoadingTabSecond(true);
      await axios
        .post(
          `${REACT_APP_API_URL}/getQuestionAnalytics`,
          {
            SurveyId: surveyId,
            SearchInputData: searchInputData,
            Limit: Limit,
            AnswerTypeId: AnswerTypeId,
            StartDate: StartDate,
            EndDate: EndDate,
            SortBy: SortBy,
          },
          {
            headers: {
              authorization: GetToken(),
            },
          },
        )
        .then(async (result) => {
          if (result.data.code === 200) {
            setDetailGraph(result.data.data);
            setQuestionTypes(result.data.data.questionTypes);
            setActivePage(limit);
            setTotalQuestions(result.data.data.totalQuestions);
          } else {
            history.goBack();
          }
          setLoading(false);
          setLoadingTabSecond(false);
        })
        .catch((err) => {
          setLoading(false);
          setLoadingTabSecond(false);
          if (err.response) {
            Error(err.response.status, err.response.data.message);
          } else if (err.request) {
            Error(err.request.status, err.request.data.message);
          } else {
            Error(404, "Something went wrong.");
          }
        });
      window.scrollTo(0, 0);
    };
    detailGraphsPageChange(
      limit,
      searchInputData,
      answerTypeId,
      startDate,
      endDate,
      sortBy,
    );
  };

  useEffect(() => {
    if (activePage === 1) {
      setPageNumberCount(activePage);
    } else {
      let a = 0;
      for (let i = 1; i < activePage; i++) {
        a = a + 5;
      }
      setPageNumberCount(a + 1);
    }
  }, [activePage]);

  const getAllQue = async () => {
    setLoading(true);
    await axios
      .post(
        `${REACT_APP_API_URL}/getQuestionAnalytics`,
        {
          SurveyId: surveyId,
          Limit: 0,
        },
        {
          headers: {
            authorization: GetToken(),
          },
        },
      )
      .then(async (result) => {
        if (result.data.code === 200) {
          await setAllQuestions(result.data.data.questionAnalytics);
        } else {
          history.goBack();
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          Error(err.response.status, err.response.data.message);
        } else if (err.request) {
          Error(err.request.status, err.request.data.message);
        } else {
          Error(404, "Something went wrong.");
        }
      });
    window.scrollTo(0, 0);
  };

  const changeFilterBox = async () => {
    if (filterButton == "hide") {
      setFilterButton("show");
    } else {
      setFilterButton("hide");
    }
  };

  return (
    <>
      <QuestionFilterBox
        questionTypes={questionTypes}
        answerTypeId={answerTypeId}
        setAnswerTypeId={setAnswerTypeId}
        setSearchInputData={setSearchInputData}
        searchInputData={searchInputData}
        sortBy={sortBy}
        setSortBy={setSortBy}
      />

      <center
        style={{ paddingTop: "20vh" }}
        className={loading ? "" : "d-none"}
      >
        <br />
        <h4>Loading...</h4>
      </center>
      <div className={!loading ? "" : "d-none"}>
        {totalQuestions > 0 ? (
          <>
            <div className="graph-main mb-5">
              <div className="intro-text">
                Find the detailed analysis of each survey question and details
                of total respondents here
              </div>
              {totalQuestions > 0 &&
              detailGraph.questionAnalytics.length > 5 ? (
                <div className="custom-pagignation my-3 d-flex align-items-center justify-content-between">
                  <Pagination>
                    <Pagination.First
                      className="first-icon"
                      onClick={() => setLimit(1)}
                      disabled={PageNumberCount - 4 < 0}
                    />
                    <Pagination.Prev
                      className="prev-icon"
                      onClick={() => setLimit(Math.floor(PageNumberCount / 5))}
                      disabled={PageNumberCount - 4 < 0}
                    />
                    {items}
                    <Pagination.Next
                      className="next-icon"
                      onClick={() =>
                        setLimit(Math.ceil(PageNumberCount / 5) + 1)
                      }
                      disabled={PageNumberCount + 4 >= totalQuestions}
                    />
                    <Pagination.Last
                      className="last-icon"
                      onClick={() => setLimit(Math.ceil(totalQuestions / 5))}
                      disabled={PageNumberCount + 4 >= totalQuestions}
                    />
                  </Pagination>
                  <span className="text-end custom-pagination-label">
                    {PageNumberCount} -{" "}
                    {totalQuestions < PageNumberCount + 4
                      ? totalQuestions
                      : PageNumberCount + 4}{" "}
                    of {totalQuestions} Questions
                  </span>
                </div>
              ) : (
                <>
                  {totalQuestions <= 0 ? (
                    <p className="text-center m-5 p-5">No questions found</p>
                  ) : (
                    <></>
                  )}
                </>
              )}
              <center
                style={{ paddingTop: "20vh" }}
                className={loading ? "" : "d-none"}
              >
                <br />
                <h4>Loading...</h4>
              </center>
              <div className={!loading ? "" : "d-none"}>
                {!detailGraph && !detailGraph.questionAnalytics && (
                  <div className="question-graph m-5 p-5 text-center">
                    No questions found
                  </div>
                )}
                {detailGraph && !detailGraph.questionAnalytics && (
                  <div className="question-graph m-5 p-5 text-center">
                    No questions found
                  </div>
                )}
                {detailGraph &&
                  detailGraph.questionAnalytics &&
                  detailGraph.questionAnalytics.map((data, index) => (
                    <div
                      className="question-graph shadow-sm border"
                      key={index}
                    >
                      <Row>
                        <Col lg={12}>
                          <b className="question-statement">
                            #{PageNumberCount + index}. {data.QuestionText}
                          </b>
                        </Col>

                        {(() => {
                          switch (data.AnswerTypeId) {
                            case "b166063b-0740-11ec-af38-1908de41ac9c":
                              return (
                                <Col lg={12}>
                                  <div className="individual-graph">
                                    <span className="total-responses">
                                      Responses: {data.total ? data.total : "0"}
                                    </span>
                                    <div className="">
                                      {data.total == 0 ? (
                                        <small className="d-block text-danger mt-1 fw-light">
                                          {" "}
                                          No response record found for this
                                          question
                                        </small>
                                      ) : (
                                        <QuestionMCQChart
                                          chartData={data.child}
                                          QuestionNo={PageNumberCount + index} //"Q" + (index + 1) + ". " +
                                          QuestionText={data.QuestionText} //"Q" + (index + 1) + ". " +
                                          surveyDetails={surveyDetails}
                                          QuestionDetails={data}
                                          Key={"chart_text"}
                                          Value={"responses"}
                                          optionText={"option_text"}
                                          divId={`graph_${index}`}
                                        />
                                      )}
                                      <div className="mt-5">
                                        <GraphQuestionsGrid
                                          gridData={data.child}
                                          otherData={data.otherData}
                                          QuestionText={data.QuestionText}
                                          QuestionNo={PageNumberCount + index}
                                          surveyDetails={surveyDetails}
                                          QuestionDetails={data}
                                        />
                                        <div>
                                          {data.otherData &&
                                            data.otherData.length > 0 && (
                                              <div className=" mt-1">
                                                <div className="k-widget k-grid p-2">
                                                  {" "}
                                                  <Col lg={12} className="mt-1">
                                                    <span className="total-responses">
                                                      Other Responses:{" "}
                                                      {data.otherData.length}
                                                    </span>
                                                    {data.otherData.length >
                                                    0 ? (
                                                      <span
                                                        onClick={() => {
                                                          setQuestionId(
                                                            index + 1,
                                                          );
                                                          setQuestionText(
                                                            data.QuestionText +
                                                              " (Others Responses) ",
                                                          );
                                                          setModalShow(true);
                                                          setpopupdata(
                                                            data.otherData,
                                                          );
                                                        }}
                                                        className="show-modal"
                                                      >
                                                        Show All Responses
                                                      </span>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </Col>
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              );
                            case "b1662a30-0740-11ec-af38-1908de41ac9c":
                              return (
                                <Col lg={12}>
                                  <div className="individual-graph">
                                    <span className="total-responses">
                                      Responses: {data.total ? data.total : "0"}
                                    </span>
                                    <div className="">
                                      {data.total == 0 ? (
                                        <small className="d-block text-danger mt-1 fw-light">
                                          {" "}
                                          No response record found for this
                                          question
                                        </small>
                                      ) : (
                                        <QuestionDropDownChart
                                          chartData={data.child}
                                          QuestionNo={PageNumberCount + index} //"Q" + (index + 1) + ". " +
                                          QuestionText={data.QuestionText} //"Q" + (index + 1) + ". " +
                                          surveyDetails={surveyDetails}
                                          QuestionDetails={data}
                                          Key={"chart_text"}
                                          Value={"responses"}
                                          optionText={"option_text"}
                                          divId={`graph_${index}`}
                                        />
                                      )}
                                      <div className="mt-5">
                                        <GraphQuestionsGrid
                                          gridData={data.child}
                                          QuestionText={data.QuestionText}
                                          QuestionNo={PageNumberCount + index}
                                          surveyDetails={surveyDetails}
                                          QuestionDetails={data}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              );

                            case "b1662e42-0740-11ec-af38-1908de41ac9c":
                              return (
                                <Col lg={12}>
                                  <div className="individual-graph">
                                    <span className="total-responses">
                                      Responses: {data.total ? data.total : "0"}
                                    </span>
                                    <div className="">
                                      {data.total == 0 ? (
                                        <small className="d-block text-danger mt-1 fw-light">
                                          {" "}
                                          No response record found for this
                                          question
                                        </small>
                                      ) : (
                                        <QuestionMultipleMCQChart
                                          chartData={data.child}
                                          QuestionNo={PageNumberCount + index} //"Q" + (index + 1) + ". " +
                                          QuestionText={data.QuestionText} //"Q" + (index + 1) + ". " +
                                          surveyDetails={surveyDetails}
                                          QuestionDetails={data}
                                          Key={"chart_text"}
                                          Value={"responses"}
                                          optionText={"option_text"}
                                          divId={`graph_${index}`}
                                        />
                                      )}
                                      <div className="mt-5">
                                        <GraphQuestionsGrid
                                          gridData={data.child}
                                          QuestionText={data.QuestionText}
                                          QuestionNo={PageNumberCount + index}
                                          surveyDetails={surveyDetails}
                                          QuestionDetails={data}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              );
                            case "77b55f4a-639e-4708-9412-5b46f7e3972b":
                              return (
                                <Col lg={12}>
                                  <div className="individual-graph">
                                    <span className="total-responses">
                                      Responses: {data.total ? data.total : "0"}
                                    </span>
                                    <div className="">
                                      {data.total == 0 ? (
                                        <small className="d-block text-danger mt-1 fw-light">
                                          {" "}
                                          No response record found for this
                                          question
                                        </small>
                                      ) : (
                                        <QuestionRatingChart
                                          chartData={data.child}
                                          QuestionNo={PageNumberCount + index} //"Q" + (index + 1) + ". " +
                                          QuestionText={data.QuestionText} //"Q" + (index + 1) + ". " +
                                          surveyDetails={surveyDetails}
                                          QuestionDetails={data}
                                          Key={"option_text"}
                                          Value={"responses"}
                                          optionText={"option_text"}
                                          divId={`graph_${index}`}
                                        />
                                      )}
                                      <div className="mt-5">
                                        <GraphQuestionsGrid
                                          gridData={data.child}
                                          QuestionText={data.QuestionText}
                                          QuestionNo={PageNumberCount + index}
                                          surveyDetails={surveyDetails}
                                          QuestionDetails={data}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              );
                            case "ec856a6e-a071-4496-829e-ce407ad3d3fa":
                              return (
                                <Col lg={12}>
                                  <div className="individual-graph">
                                    <span className="total-responses">
                                      Responses: {data.total ? data.total : "0"}
                                    </span>
                                    <div className="">
                                      {data.total == 0 ? (
                                        <small className="d-block text-danger mt-1 fw-light">
                                          {" "}
                                          No response record found for this
                                          question
                                        </small>
                                      ) : (
                                        <QuestionGroupRatingChart
                                          chartData={data.child}
                                          QuestionNo={PageNumberCount + index} //"Q" + (index + 1) + ". " +
                                          QuestionText={data.QuestionText} //"Q" + (index + 1) + ". " +
                                          surveyDetails={surveyDetails}
                                          QuestionDetails={data}
                                          Key={"chart_text"}
                                          optionText={"option_text"}
                                          Value={"visits"}
                                          divId={`graph_${index}`}
                                        />
                                      )}
                                      <div className="mt-5">
                                        <QuestionGroupRatingGrid
                                          gridData={data.child}
                                          QuestionText={data.QuestionText}
                                          QuestionNo={PageNumberCount + index}
                                          surveyDetails={surveyDetails}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              );

                            default:
                              return (
                                data.child && (
                                  <Col lg={12} className="mt-1">
                                    <span className="total-responses">
                                      Responses: {data.total ? data.total : "0"}
                                    </span>
                                    {data.child.length > 0 ? (
                                      <span
                                        onClick={() => {
                                          setQuestionId(
                                            PageNumberCount + index,
                                          );
                                          setQuestionText(data.QuestionText);
                                          setModalShow(true);
                                          setpopupdata(data.child);
                                        }}
                                        className="show-modal"
                                      >
                                        Show All Responses
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                  </Col>
                                )
                              );
                          }
                        })()}
                      </Row>
                    </div>
                  ))}
              </div>
              {totalQuestions > 5 ? (
                <div className="custom-pagignation my-3 d-flex align-items-center justify-content-between">
                  <Pagination>
                    <Pagination.First
                      className="first-icon"
                      onClick={() => setLimit(1)}
                      disabled={PageNumberCount - 4 < 0}
                    />
                    <Pagination.Prev
                      className="prev-icon"
                      onClick={() => setLimit(Math.floor(PageNumberCount / 5))}
                      disabled={PageNumberCount - 4 < 0}
                    />
                    {items}
                    <Pagination.Next
                      className="next-icon"
                      onClick={() =>
                        setLimit(Math.ceil(PageNumberCount / 5) + 1)
                      }
                      disabled={PageNumberCount + 4 >= totalQuestions}
                    />
                    <Pagination.Last
                      className="last-icon"
                      onClick={() => setLimit(Math.ceil(totalQuestions / 5))}
                      disabled={PageNumberCount + 4 >= totalQuestions}
                    />
                  </Pagination>
                  <span className="text-end custom-pagination-label">
                    {PageNumberCount} -{" "}
                    {totalQuestions < PageNumberCount + 4
                      ? totalQuestions
                      : PageNumberCount + 4}{" "}
                    of {totalQuestions} Questions
                  </span>
                </div>
              ) : (
                <>
                  {totalQuestions <= 0 ? (
                    <p className="text-center m-5 p-5">No questions found</p>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </div>
          </>
        ) : (
          <Row className={loadingTabSecond ? "d-none" : ""}>
            <Col lg={12} className="text-center">
              <div className="py-5">
                <h5 className="text-danger">
                  No questions found for selected filters
                </h5>
              </div>
            </Col>
          </Row>
        )}
      </div>
      <QuestionModal
        show={modalShow}
        questionNo={questionId}
        QuestionText={questionText}
        popupdata={popupdata}
        surveyDetails={surveyDetails}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default QuestionAnalyticsTab;
